export default __webpack_public_path__ + "static/media/homei3.b8fb1386.png";